import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import summaryStop from "../../images/summary_stop.svg";

/**
 * Renders a notification that the meeting summary is ready with a button to view it.
 * 
 * @param {Object} props
 * @param {string} props.aimsUuid - The ID of the ready summary
 * @param {Function} props.onViewSummary - Callback function when the "See my summary" button is clicked
 */
const SummaryReady = ({ aimsUuid, onViewSummary }) => (
  <Column alignmentHorizontal="start" width="100%" position="relative" spacing="none" spacingInset="none">
    <Row spacing="none" spacingInset="none">
      <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
        <Box type="outline" spacingInset="none" minWidth="15px" />
      </Theme>
      <Box width="340px" position="relative">
        <img src={summaryStop} alt="summaryReady" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
      </Box>
    </Row>
    <Row height="16px" spacing="none" />
    <Row spacing="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" minWidth="68px"/>
        </Theme>
        <Text fontFamily="amazonEmber" type="h50">
          Your summary is ready
        </Text>
      </Row>
    </Row>
    <Row height="32px" spacing="none" />
    <Row spacing="none" spacingInset="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" minWidth="68px" />
        </Theme>
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none">
            <Theme tokens={{ 
              buttonBackgroundColorPrimaryDefault: "#006D5B",
              buttonBackgroundColorPrimaryHover: "#005345",
              buttonBackgroundColorPrimaryPressed: "#003F33",
            }}>
              <Button size="small" onClick={onViewSummary} type="tertiary">
                See my summary
              </Button>
            </Theme>
          </Box>
        </Theme>
      </Row>
    </Row>
  </Column>
);

export default SummaryReady;
